import { ApiEnvironment } from '../../models/api-environment';

export class MapManagementServiceEnvironment extends ApiEnvironment {
  get rulesUrl() {
    return `${this.baseUrl}/api/rules`;
  }

  get schedulerConfigurationUrl() {
    return `${this.baseUrl}/api/scheduler/configuration`;
  }

  get snapshotUrl() {
    return `${this.baseUrl}/api/snapshot`;
  }

  get snapshotDevicesUrl() {
    return `${this.baseUrl}/api/snapshot/devices`;
  }

  get templatesUrl() {
    return `${this.baseUrl}/api/templates`;
  }

  override resolve(environment: unknown) {
    return environment instanceof MapManagementServiceEnvironment
      ? environment
      : this;
  }
}

export const mapManagementServiceEnvironment =
  new MapManagementServiceEnvironment();
